import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { FilterOptions } from '@shared/models/filter.models';
import {
  ListingDetail,
  ListingResponse,
  ListingSummary,
} from '@shared/models/listing.models';
@Injectable({
  providedIn: 'root',
})
export class ListingsService {
  constructor(private http: HttpClient) {}
  /**
   * Get filter data
   */
  getFilter(): Observable<FilterOptions> {
    return this.http
      .get<FilterOptions>(`${environment.apiUrl}/listings/filters/`)
      .pipe(catchError(this.handleError));
  }

  /**
   * Get listings based on filter query parameters
   */
  getListings(queryString: string): Observable<ListingResponse> {
    return this.http
      .get<ListingResponse>(`${environment.apiUrl}/listings/${queryString}`)
      .pipe(catchError(this.handleError));
  }

  /**
   * Get listings based on filter query parameters

   */
  getFrontpageListings(queryParams: string): Observable<ListingSummary[]> {
    return this.http
      .get<
        ListingSummary[]
      >(`${environment.apiUrl}/listings/frontpage/?${queryParams}`)
      .pipe(catchError(this.handleError));
  }

  /**
   * Get listings count based on filter query parameters
   * @param queryParams - URL query parameters string (should include '?' prefix)
   */
  getListingCount(queryParams: string): Observable<{ count: number }> {
    return this.http
      .get<{
        count: number;
      }>(`${environment.apiUrl}/listings/count/${queryParams}`)
      .pipe(catchError(this.handleError));
  }

  /**
   * Get data for a specific car listing
   * @param id - ID of the car listing
   */
  getCarData(id: string): Observable<ListingDetail> {
    return this.http
      .get<ListingDetail>(`${environment.apiUrl}/listings/${id}/`)
      .pipe(catchError(this.handleError));
  }

  /**
   * Error handler for HTTP requests
   */
  private handleError(error: HttpErrorResponse) {
    const errorMessage = `Error Code: ${error.status}, Message: ${error.message}`;
    return throwError(() => new Error(errorMessage));
  }
}
